import React from 'react';
import PageForm from "components/pageForm";
import {Outlet} from "react-router-dom";
import SubNavbar from "components/SubNavbar/SubNavbar";
import {TabF, TabsF} from "components/tabs/tabfile";

const Profil = () => {
    const role = localStorage.getItem('rUser');
    const isAdmin = role === '225';

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-stretch h-full">
                        <div className="w-full flex flex-col tab:flex-row tab:justify-between gap-3">
                            <div className="flex items-center h-full">
                                <TabsF>
                                    <TabF label={"myAccountCompany"} tabName={'Compte'}/>
                                    <TabF label={"legalInformation"} tabName={'Informations légales'}/>
                                    {isAdmin && <TabF label={"team"} tabName={'Équipe'}/>}
                                    {isAdmin && <TabF label={"permissions"} tabName={'Permissions'}/>}
                                </TabsF>
                            </div>
                        </div>
                    </div>
                </SubNavbar>
                <div className="col-span-12">
                    <Outlet />
                </div>
            </PageForm>
        </>
    );
};

export default Profil;